export default "__VITE_ASSET__sA1Pe$aP5_D8DYp0gfXE7g__"